<template>
  <div class="info-flyout">
    <!-- Toggle button -->
    <div
      :class="{
        'toggle-button': true,
        'info-flyout__toggle-button': true,
        'info-flyout__toggle-button--no-bottom-margin': !isOpened,
      }"
      @click="isOpened = !isOpened"
    >
      <IconEmbedded v-if="!isOpened" class="toggle-button__caret-icon" name="caret-bottom_4" :size="14" color="rgba(17, 134, 137, 1)" />
      <IconEmbedded v-else class="toggle-button__caret-icon" name="caret-top_4" :size="14" color="rgba(17, 134, 137, 1)" />

      <div class="toggle-button__divider"></div>

      <IconEmbedded class="toggle-button__bulb-icon" name="bulb_2-5" :size="17" color="rgba(17, 134, 137, 1)" />
      <div class="toggle-button__text">How Creator Visits Work</div>
    </div>
    <!-- / Toggle button -->

    <TransitionedHeightAuto :isOpened="isOpened">
      <div class="info-flyout__content">
        <div class="info-flyout__content-left-col">
          <!--<div class="info-flyout__plain-text">
            {{
              `Rich content via the Shrpa Creator Network and Shrpa support and guarantees. Creators that visit your destination, highlight locations with your guidance, and deliver photos, videos, and Shrpa adventures.`
            }}
          </div>-->

          <ul class="info-flyout__stages-list">
            <!-- Stage snippet -->
            <li
              :class="{
                'stage-snippet': true,
                'stage-snippet--first': index === 0,
                'stage-snippet--last': index === stagesList.length - 1,
                'info-flyout__stage-snippet': true,
              }"
              v-for="(stage, index) in stagesList"
              :key="stage.title"
            >
              <div class="stage-snippet__number">
                {{ index + 1 }}
              </div>
              <div class="stage-snippet__text-container">
                <h4 class="global-h4 stage-snippet__title">
                  {{ stage.title }}
                </h4>
                <div class="stage-snippet__description">
                  {{ stage.description }}
                </div>
              </div>
            </li>
            <!-- / Stage snippet -->
          </ul>
        </div>

        <div class="info-flyout__content-right-col">
          <h3 class="global-h3" style="margin-bottom: 10px">FAQ</h3>
          <ul class="global-ul">
            <li>Utilizes the Shrpa Creator Network to source creators in your area.</li>
            <li>Shrpa pays the creator based on their experience with Creator Visits.</li>
            <li>If a more flexible, self-managed collaboration is needed, consider Custom Collabs.</li>
          </ul>
        </div>
      </div>
    </TransitionedHeightAuto>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

// Components
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import TransitionedHeightAuto from "@components/ui/TransitionedHeightAuto.vue";

// Stages list ================================================================
const stagesList = [
  { title: "Specify What You Want", description: "Tell us what you would like highlighted in your destination." },
  { title: "Creators Apply", description: "We'll share those details with creators in your area, who can then apply to participate." },
  { title: "Choose the Creator", description: "You can choose which creator you like best for the visit." },
  { title: "Creator Visits and Delivers", description: "After the creator visits, they will craft and share the content that is now yours to use!" },
];

// Is Opened ==================================================================
const isOpened = ref<boolean>(false);
</script>

<style scoped lang="scss">
@import "@/scss/howDoesItWorkSpoiler.scss";
</style>
